import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import {JIRA_AMENDMENT_URL} from '@account/config';
import {JIRA_KEY_RE} from '@account/utils/errors';
import {formatDateUTC} from '@account/utils/dates';

const DeleteTermDialog = ({term, onClose, onConfirm, isLoading}) => {
  const [ticketRef, setTicketRef] = useState('');
  const isTicketValid = JIRA_KEY_RE.test(ticketRef.trim());
  const canSubmit = isTicketValid;

  return (
    <Dialog maxWidth="sm" fullWidth open onClose={onClose}>
      <DialogTitle>Delete access period?</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          This will delete the access period{' '}
          <b>
            {formatDateUTC(term.start_date)} &ndash;{' '}
            {formatDateUTC(term.end_date)}
          </b>{' '}
          and release its quota back to this account&apos;s balance. This cannot
          be undone.
        </Typography>

        <TextField
          label="Support ticket ref"
          value={ticketRef}
          onChange={e => setTicketRef(e.target.value)}
          placeholder="CGO-1234"
          error={!!ticketRef.trim() && !isTicketValid}
          helperText={
            ticketRef.trim() && !isTicketValid ? (
              'Must match format PROJECT-1234 (e.g. CGO-1234)'
            ) : ticketRef.trim() ? (
              'Format: PROJECT-1234 (e.g. CGO-1234)'
            ) : (
              <span>
                Need approval first?{' '}
                <Link
                  href={JIRA_AMENDMENT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Request amendment approval
                </Link>
              </span>
            )
          }
          fullWidth
          required
          sx={{mt: 2}}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(ticketRef.trim())}
          variant="contained"
          color="error"
          disabled={isLoading || !canSubmit}
        >
          {isLoading ? 'Deleting…' : 'Delete access period'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteTermDialog.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  term: PropTypes.shape({
    end_date: PropTypes.string,
    start_date: PropTypes.string,
  }).isRequired,
};

export default DeleteTermDialog;
